import createClient from "openapi-fetch";
import type { paths } from "./loyalty-api.schema";

export const LOYALTY_MARKETS = ["NO", "SE", "DK", "FI", "EE", "DE", "AT"] as const;
export type LoyaltyMarket = (typeof LOYALTY_MARKETS)[number];

export const isLoyaltyMarket = (country: string): country is LoyaltyMarket =>
	LOYALTY_MARKETS.includes(country as LoyaltyMarket);

export const createYotpoLoyalty = ({
	apiKey,
	guid,
}: {
	apiKey: string;
	guid: string;
}) => {
	return createClient<paths>({
		baseUrl: "https://loyalty.yotpo.com",
		headers: {
			"x-guid": guid,
			"x-api-key": apiKey,
		},
	});
};

export type { paths };
